import React from "react";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { CloseIcon } from "@src/components/BillingPanel/components/ManageSubscriptionsDialog/Forms/CloseIcon";
import { ContentProps } from "@src/components/BillingPanel/components/ManageSubscriptionsDialog/types";

export const PauseContent = ({ setAction, handleClose }: ContentProps) => {
  return (
    <>
      <DialogTitle sx={{ padding: "0 0 20px 0" }}>
        <IgTypography variant={"h2"}>Pause Plan</IgTypography>
        <CloseIcon handleClose={handleClose} />
      </DialogTitle>
      <DialogContent sx={{ padding: "0 0 20px 0" }}>
        <IgTypography>
          Pause your plan for $9/month to retain access to your past test and
          personalization analytics. While paused, your store will continue
          collecting data, setting you up for even more powerful insights in the
          future.
          <br />
          <br />
          Your plan will remain active until the end of your current billing
          period, after which the pause will take effect.
        </IgTypography>
      </DialogContent>
      <DialogActions>
        <IgButton variant={"contained"} onClick={() => setAction("pauseForm")}>
          Pause Plan
        </IgButton>
      </DialogActions>
    </>
  );
};
